import { Dispatch, SetStateAction, memo } from 'react';
import { Grid, Text } from '@mantine/core';
import { type MRT_PaginationState } from 'mantine-react-table';
import { useTranslation } from 'react-i18next';
import { formatMoneyString } from '../../../utils/strings';
import Table from '../../../components/Table';

export default memo(function TableView({
  salesData = [],
  totalRowsCount = 0,
  pages = 0,
  isError = false,
  isLoading = false,
  pagination,
  setPagination,
  footerData = {
    totalPieces: 0,
    totalSales: 0,
    totalPaid: 0,
    totalUnpaid: 0,
    totalOrders: 0
  }
}: {
  salesData: {
    date: string;
    ordersQty: number;
    ordersUnpaidTotal: number;
    salesTotal: number;
    totalProductPieces: number;
  }[];
  totalRowsCount: any;
  pages: any;
  isError: boolean;
  isLoading: boolean;
  pagination: MRT_PaginationState;
  setPagination: Dispatch<SetStateAction<MRT_PaginationState>>;
  footerData: {
    totalPieces: number;
    totalSales: number;
    totalPaid: number;
    totalUnpaid: number;
    totalOrders: number;
  };
}) {
  const { t } = useTranslation(['FieldName']);
  const columns = [
    {
      accessorFn: (row) => row.date,
      header: t('FieldName:date')
    },
    {
      accessorFn: (row) => row.ordersQty,
      header: t('FieldName:orders'),
      Footer: () => {
        return (
          <Grid>
            <Grid.Col span={12}>
              <Text fw={'bold'}>{footerData?.totalOrders}</Text>
            </Grid.Col>
          </Grid>
        );
      }
    },
    {
      accessorFn: (row) => row.totalProductPieces,
      header: t('FieldName:pieces'),
      Footer: () => {
        return (
          <Grid>
            <Grid.Col span={12}>
              <Text fw={'bold'}>{footerData?.totalPieces}</Text>
            </Grid.Col>
          </Grid>
        );
      }
    },
    {
      accessorFn: (row) => formatMoneyString((row.salesTotal || 0).toFixed(2)),
      header: t('FieldName:total'),
      Footer: () => {
        return (
          <Grid>
            <Grid.Col span={12}>
              <Text fw={'bold'}>{formatMoneyString(footerData?.totalSales.toFixed(2))}</Text>
            </Grid.Col>
          </Grid>
        );
      }
    },
    {
      accessorFn: (row) => formatMoneyString((row.ordersUnpaidTotal || 0).toFixed(2)),
      header: t('FieldName:amountDue'),
      Footer: () => {
        return (
          <Grid>
            <Grid.Col span={12}>
              <Text fw={'bold'}>{formatMoneyString(footerData?.totalUnpaid.toFixed(2))}</Text>
            </Grid.Col>
          </Grid>
        );
      }
    }
  ];

  return (
    <>
      <Grid gutter="md">
        <Grid.Col span={12}>
          <Table
            tableColumns={columns}
            pagination={pagination}
            setPagination={setPagination}
            tableData={salesData}
            isError={isError}
            paginationIsLoading={isLoading}
            numPages={pages}
            totalRowsCount={totalRowsCount}
            overrideTableConfigs={{
              manualPagination: false
            }}
          />
        </Grid.Col>
      </Grid>
    </>
  );
});
